import * as PIXI from "pixi.js";
import { AbstractView } from "../../view/AbstractView";
/*
 * AbstractPanelLayout.ts
 */
export class AbstractPanelLayout {
    constructor() {
        this.size = new PIXI.Point(0, 0);
        this.create();
    }
    equals(other) {
        return this.size.equals(other.size);
    }
    create() {
        this.createHolder();
    }
    createHolder() {
        this.holder = new PIXI.Container();
    }
    getHolder() {
        return this.holder;
    }
    addChild(child, position) {
        //edge case - child may not have a transform briefly during a rotate event. This will resolve itself in post-rotate
        if (child.transform) {
            if (!this.containsChild(child)) {
                this.holder.addChild(child);
            }
            child.position.copyFrom(position);
        }
    }
    removeChild(child) {
        if (this.containsChild(child)) {
            this.holder.removeChild(child);
        }
    }
    getChildSize(a) {
        let size = new PIXI.Point(0, 0);
        if (a instanceof AbstractView) {
            let view = a;
            size.x = view.getWidth();
            size.y = view.getHeight();
        }
        else {
            let container = a;
            size.x = container.width;
            size.y = container.height;
        }
        return size;
    }
    containsChild(child) {
        return this.holder.children.indexOf(child) >= 0;
    }
    apply(children) {
    }
    setPanel(panel) {
        this.panel = panel;
        this.panel.getContainer().addChild(this.holder);
    }
    clone() {
        return null;
    }
    getSize() {
        return this.size;
    }
}
//# sourceMappingURL=AbstractPanelLayout.js.map